// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1GC9X","list_item":"styles_list_item__2s2QH","more":"styles_more__2fQue"};